import React, { useState, useEffect, useContext } from 'react';

// React router dom
import { useHistory } from 'react-router-dom';

// Reactfire (firebase)
import { useFirebaseApp } from 'reactfire';

// Bootstrap e outras bibliotecas de estilização / ícones
import { NavDropdown, Navbar, Nav } from 'react-bootstrap';
import { FaSignOutAlt } from 'react-icons/fa';

// Context
import AuthContext from '../../Context/context';

// Images
import Freetakistan from '../../assets/images/Freetakistan.png';

// Firebase
import { db } from '../../utils/firebaseConfig';

import './style.css';

const Header = () => {
    // history para enviar usuário à uma página específica
    let history = useHistory();
    let firebase = useFirebaseApp();

    const { currentUser } = useContext(AuthContext)

    const [isLogged, setIsLogged] = useState(false);
    const [isAdmin, setIsAdmin] = useState(false);

    const getToken = () => {
        return localStorage.getItem('_tok_user');
    }

    useEffect(() => {
        // Verificação para caso usuário estiver logado, ou não
        getToken() !== null ? setIsLogged(true) : setIsLogged(false);
        verifyUserFunction();
    })

    // Botão logout
    const Logout = () => {
        // Logout com Firebase
        firebase.auth().signOut()
            .then(resp => {
                // Remove o token do localStorage
                localStorage.removeItem('_tok_user');

                // Envia usuário para login
                history.push('/');

                // Recarrega a página para atualizar o Header
                window.location.reload();
            })
    }

    const verifyUserFunction = () => {
        let user: any = firebase.auth().currentUser;
        // Procura no firestore o id do usuário
        if(user !== null){
            db.collection('Usuarios').doc(user.uid).get()
                .then(resp => {
                    // Verificação se o usuário é admin
                    setIsAdmin(resp.data()?.isAdmin ? true : false);
                })
        }
    }

    return (
        <div>
            <Navbar collapseOnSelect expand="lg" bg="dark" variant="dark">
                <Navbar.Brand href="/"><img className="logo-freetakistan" src={Freetakistan} alt="Freetakistan Logo" />Free Takistan</Navbar.Brand>
                <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                <Navbar.Collapse id="responsive-navbar-nav">
                    {/* Caso não autenticado */}
                    {
                        !isLogged &&
                        <Nav className="mr-auto">
                            <Nav.Link href="/">Home</Nav.Link>
                            <NavDropdown title="Nossos Mods" id="collasible-nav-dropdown">
                                <NavDropdown.Item href="/categorias/arma">Arma 2</NavDropdown.Item>
                                <NavDropdown.Item href="/categorias/rfactor">Rfactor 2</NavDropdown.Item>
                            </NavDropdown>
                            <Nav.Link href="/tutoriais">Tutoriais</Nav.Link>
                        </Nav>
                    }

                    {/* Caso autenticado */}
                    {
                        isLogged &&
                        <Nav className="mr-auto">
                            <Nav.Link href="/">Home</Nav.Link>
                            <NavDropdown title="Nossos Mods" id="collasible-nav-dropdown">
                                <NavDropdown.Item href="/categorias/arma">Arma 2</NavDropdown.Item>
                                <NavDropdown.Item href="/categorias/rfactor">Rfactor 2</NavDropdown.Item>
                            </NavDropdown>
                            <Nav.Link href="/tutoriais">Tutoriais</Nav.Link>
                            {
                                isAdmin &&
                                <Nav.Link href="/usuarios">Lista de usuários</Nav.Link>
                            }
                        </Nav>
                    }

                    {/* Caso não autenticado */}
                    {
                        !isLogged &&
                        <Nav>
                            <Nav.Link href="/login">Login</Nav.Link>
                            <Nav.Link href="/cadastro">Cadastro</Nav.Link>
                        </Nav>
                    }

                    {/* Caso autenticado */}
                    {
                        isLogged &&
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <div className="item-nome">
                                <span>{currentUser?.email}</span>
                            </div>
                            <div className="item-logout" onClick={event => {
                                event.preventDefault();
                                Logout();
                            }}>
                                <FaSignOutAlt />
                                <span>Sair</span>
                            </div>
                        </div>
                    }
                </Navbar.Collapse>
            </Navbar>
        </div>
    );
}

export default Header;